module.exports = __webpack_public_path__ + "static/media/asteroid.e191290d.png";